export default "__VITE_ASSET__a0940bd2__"